import DxButton from "devextreme-vue/button";
import DxCheckBox from "devextreme-vue/check-box";
import DxTextBox from "devextreme-vue/text-box";
import DxValidationGroup from "devextreme-vue/validation-group";
import DxValidator, { DxRequiredRule, DxEmailRule } from "devextreme-vue/validator";

import { authService } from '../../../services/auth.service';

import notify from 'devextreme/ui/notify';

export default {
  name: "forgotPassword",
  data() {
    return {
      title: process.env.VUE_APP_PROJECT_NAME,
      mailAddress: "",
    };
  },
  methods: {
    onSendClick(e) {

      if (!e.validationGroup.validate().isValid) return;

      authService.forgotPassword(this.mailAddress)
        .then(
          success => {
            notify({
              message: success.message,
              shading: true
            }, success.messageType == 1 ? 'success' : 'error', process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
          },
          error => {
            console.log(error)
          }
        );
    }
  },
  components: {
    DxButton,
    DxCheckBox,
    DxTextBox,
    DxValidator,
    DxRequiredRule,
    DxEmailRule,
    DxValidationGroup
  }
};